import React, { FC, useCallback, useEffect, useState } from 'react';
import Form, { FormSchema } from '../../form/Form';
import { Button, Card, Divider, message, Typography } from 'antd';
import './RequestPasswordRest.less';
import { useHistory } from 'react-router-dom';
import { useConnection, useUserInfo } from '../../connection/Application';
const { Title } = Typography;

const schema: FormSchema = [
  {
    id: 'email',
    type: 'string',
    props: { placeholder: 'Email address' },
    options: {
      rules: [
        { required: true, whitespace: true, message: 'Email is required' },
        { type: 'email', message: 'Invalid Email' },
      ],
    },
  },
];

const RequestPasswordRest: FC = () => {
  const history = useHistory();
  const connection = useConnection();
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const user = useUserInfo();
  useEffect(() => {
    if (user) {
      history.replace('/webux/my-goals');
    }
  }, [history, user]);
  const onSubmit = useCallback(
    (formData) => {
      setLoading(true);
      connection
        .post('users/request-password-reset', { email: formData.email })
        .then(() => {
          message.success('Check your email to reset password');
          history.replace('/login');
        })
        .catch((error) => {
          form.setFields([{ name: 'email', errors: [error.message] }]);
        })
        .finally(() => setLoading(false));
    },
    // eslint-disable-next-line
    [connection],
  );
  return (
    <div className="login">
      <Card className="login-card">
        <img src="../../images/logo.png" alt="logo" />
        <Divider orientation="center">
          <Title level={5}>Request Password Reset</Title>
        </Divider>
        <Form form={form} onFinish={onSubmit} layout="vertical">
          <Form.Items schema={schema} />
          <Button htmlType="submit" type="primary" block loading={loading}>
            Request
          </Button>
        </Form>
        <Divider orientation="center" />
        <Button type="link" size="large" onClick={() => history.replace('/login')} block>
          login?
        </Button>
      </Card>
    </div>
  );
};

export default RequestPasswordRest;
// password-rest
